import { render } from "./PhoneNumberField.vue?vue&type=template&id=13afbf18"
import script from "./PhoneNumberField.vue?vue&type=script&lang=js"
export * from "./PhoneNumberField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PhoneNumberField.vue"]])

export default __exports__